export const AUTH_MODULE_NAME = "auth";
